module.exports = __webpack_public_path__ + "static/media/AFP-ERP-3.dd40e213.jpg";